import { defaultCategory, defaultFilterSgaCategories } from "./state";

/**
 * Mutación que lista las categorías de SGA .
 *
 * @param {*} state.categories - Estado de las categorías de SGA.
 * @param categories - Categorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setCategoriesSga(state, categories) {
    state.categories = categories;
}

/**
 * Mutación que establece la acción a realizar.
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar.
 * @return {void}
 * @author Brandon Torres
 */
export function setActionCategory(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la categoría por defecto.
 *
 * @param {*} state.category - Estado de la categoría.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultCategorySga(state) {
    state.category = defaultCategory();
}

/**
 * Mutación que establece el filtro de categorías de SGA por defecto.
 *
 * @param {*} state.filterCategoriesSga - Estado del filtro de categorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSgaCategories(state) {
    state.filterCategoriesSga = defaultFilterSgaCategories();
}

/**
 * Mutación que establece la cantidad de categorías por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterCategoriesSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterCategoriesSga = {
        ...state.filterCategoriesSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterCategoriesSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterCategoriesSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de categorías.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterCategoriesSga.page - Página actual.
 * @param {*} state.filterCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterCategoriesSga.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateCategoriesSga(state, paginate) {
    state.filterCategoriesSga = {
        ...state.filterCategoriesSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la categoría de SGA.
 *
 * @param {*} state.category - Estado de la categoría.
 * @param category - Categoría de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setCategorieSga(state, category) {
    state.category = {
        id: category.id,
        name: category.name,
        sga_type_of_danger_id: category.sga_type_of_danger_id,
        sga_category_languages: category.sga_category_languages,
    };
}

/**
 * Mutación que establece las categorías activas de SGA.
 *
 * @param {*} state.activeCategories - Estado de las categorías activas de SGA.
 * @param activeCategories - Categorías activas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveCategoriesSga(state, activeCategories) {
    state.activeCategories = activeCategories;
}
